import React from "react";

import styles from "./GridSpacer.module.css";

export default function GridSpacer() {
  return <div className={styles.grid}></div>;
}
